// import { IApplicationFields } from 'interfaces_old';
import React from 'react';
import { FileUpload } from 'components';
import './renderFields.scss';
import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import {
    CustomNumberInputTextField,
    CustomTextAreaInputTextField,
    CustomTitleInputTextField,
} from 'components/MuiCompenentsCustomStyled/CustomTextFields';
import { CustomAutocomplete } from 'components/MuiCompenentsCustomStyled/CustomAutocompletes';
import { CustomDatePicker, CustomTimePicker } from 'components/MuiCompenentsCustomStyled/CustomDatePickers';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { IFormAppFieldDTO, IfileValue } from 'shared/interfaces/formApplication';
import CustomSignaturePad from 'components/MuiCompenentsCustomStyled/CustomSignaturePad';

dayjs.extend(customParseFormat);

// Use the shared interface for consistency
interface IFileValue extends IfileValue {}

export const renderField = (
    // formField: IApplicationFields,
    formField: IFormAppFieldDTO,

    fieldValue: any,
    onValueChange: (fieldIdex: number, fieldValue: string | number | boolean | IFileValue[]) => void,
    applicationId: string,
    applicationCategory: string,
    isSubmitted: boolean,
    formId?: string
) => {
    const questionTypeField = () => {
        switch (formField.type) {
            case 'text':
                return (
                    <CustomTitleInputTextField
                        label={''}
                        value={fieldValue}
                        onChange={(e) => handleValueChange(e.target.value)}
                        disabled={isSubmitted}
                    />
                );
            case 'textarea':
                return (
                    <CustomTextAreaInputTextField
                        label={''}
                        value={fieldValue}
                        onChange={(e) => handleValueChange(e.target.value)}
                        disabled={isSubmitted}
                    />
                );
            case 'checkbox':
                return (
                    <FormControlLabel
                        label={formField.label}
                        disabled={isSubmitted}
                        control={
                            <Checkbox
                                checked={Boolean(fieldValue)}
                                onChange={(e) => onValueChange(formField.fieldIndex, e.target.checked)}
                                sx={{
                                    color: '#2099B4',
                                    '&.Mui-checked': {
                                        color: '#2099B4',
                                    },
                                }}
                            />
                        }
                    />
                );

            case 'select': {
                // Select fields always have a value (default or user selection)
                // Helper function to get valid default index
                const getValidDefaultIndex = (): number => {
                    const defaultIndex = formField.defaultValues?.defaultSelectionIndex;
                    const optionsLength = formField.options?.length || 0;

                    if (defaultIndex !== undefined && defaultIndex >= 0 && defaultIndex < optionsLength) {
                        return defaultIndex;
                    }
                    return optionsLength > 0 ? 0 : 0;
                };

                // Determine select value
                let selectValue: number;
                if (fieldValue === '' || fieldValue === null || fieldValue === undefined) {
                    selectValue = getValidDefaultIndex();
                } else {
                    selectValue = Number(fieldValue);
                    // If value is invalid, use default
                    const optionsLength = formField.options?.length || 0;
                    if (isNaN(selectValue) || selectValue < 0 || selectValue >= optionsLength) {
                        selectValue = getValidDefaultIndex();
                    }
                }

                return (
                    <CustomAutocomplete
                        label={''}
                        value={selectValue}
                        onChange={handleValueChange}
                        optionsList={formField.options || []}
                        disabled={isSubmitted}
                    />
                );
            }

            case 'number':
                return (
                    <CustomNumberInputTextField
                        label={''}
                        value={fieldValue || ''}
                        onChange={(e) => handleValueChange(e.target.value)}
                        disabled={isSubmitted}
                    />
                );

            case 'file':
                return (
                    <FileUpload
                        files={formField.fileValues || []}
                        fieldIndex={formField.fieldIndex}
                        updateSelectedFiles={onValueChange}
                        applicationId={applicationId}
                        applicationCategory={applicationCategory}
                        formId={formId}
                        disabled={isSubmitted}
                    />
                );
            //Note: I'm not sure how date and time should be saved in DB' so double check its correct (ariel).
            case 'date':
                return (
                    <CustomDatePicker
                        label=""
                        value={fieldValue ? dayjs(fieldValue) : null}
                        onChange={(newValue: Dayjs | null) => {
                            if (!newValue || !newValue.isValid()) return;
                            const formattedValue = newValue.format('YYYY-MM-DD');
                            handleValueChange(formattedValue);
                        }}
                        disabled={isSubmitted}
                    />
                );

            case 'time':
                return (
                    <CustomTimePicker
                        label=""
                        value={fieldValue ? dayjs(fieldValue, 'HH:mm') : null}
                        onChange={(newValue: Dayjs | null) => {
                            if (!newValue || !newValue.isValid()) return;
                            const formattedValue = newValue.format('HH:mm');
                            handleValueChange(formattedValue);
                        }}
                        disabled={isSubmitted}
                    />
                    // <div key={formField.fieldIndex} style={{ marginBottom: '20px' }}>
                    //     <label>
                    //         {formField.label} {formField.mandatory && '*'}
                    //         <input type="time" value={fieldValue} onChange={(e)=>handleValueChange(e.target.value)} />
                    //     </label>
                    // </div>
                );

            case 'signature':
                return (
                    <CustomSignaturePad
                        value={fieldValue ?? ''}
                        onChange={(dataUrl) => onValueChange(formField.fieldIndex, dataUrl)}
                        disabled={isSubmitted}
                    />
                );

            default:
                return <div key={formField.fieldIndex}>{formField.type} not supported</div>;
        }
    };

    const handleValueChange = (newValue: string | number | boolean) => {
        // //Handle number, select and checkbox inputs states updates diferently then others
        // if (formField.type === 'number') {
        //     newValue = Number(e.target.value);
        // } else if (formField.type === 'checkbox' && e.target instanceof HTMLInputElement) {
        //     newValue = Boolean(e.target.checked);
        // } else if (formField.type === 'select' && e.target instanceof HTMLSelectElement) {
        //     newValue = e.target.selectedIndex;
        // } else {
        //     newValue = e.target.value;
        // }
        onValueChange(formField.fieldIndex, newValue);
    };

    return (
        <Tooltip title={formField.tooltip} arrow>
            <div key={formField.fieldIndex} className="question-container">
                <label className="question-label">
                    {formField.label} <span style={{ color: 'red' }}>{formField.mandatory && '*'}</span>
                </label>
                <label className="info-label">{formField.info}</label>
                {questionTypeField()}
            </div>
        </Tooltip>
    );
};
